module.exports = __webpack_public_path__ + "img/protokol_kesehatan.affdfa70.svg";